import React, { Fragment } from "react";

const Transfer = (props) => {

    return (
        <Fragment>
            <tr>
                <td>{props.transfer.origem}</td>
                <td>{props.transfer.competencia}</td>
                <td>{props.transfer.ano}</td>
                <td>{props.transfer.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2 })}</td>
                <td>{props.transfer.tipo}</td>
                <td>{props.transfer.programa ? props.transfer.programa : "Não se aplica"}</td>
                <td>{props.transfer.destinatario}</td>
            </tr>
        </Fragment >)
}

export default Transfer;